import type { InstantMessage } from '@tadpoles/common'

export function compareMessages(left: InstantMessage, right: InstantMessage): number {
    return left.captureTimestamp - right.captureTimestamp || left.id.localeCompare(right.id)
}
